import React from 'react';
import { motion } from 'framer-motion';
import { palette, season } from '../data/products';
export function Palette() {
  return <section id="palette" className="bg-bone" data-id="element-177" data-mp="3046al3klcxpj">
      <div className="mx-auto max-w-[1400px] px-6 pt-24 lg:px-12 lg:pt-32" data-id="element-178" data-mp="2l5cbtjnvkgij">
        <div className="max-w-xl" data-id="element-179" data-mp="2l7fb6uax3lzx">
          <p className="eyebrow text-clay" data-id="element-180" data-mp="2q3vxdiyk3qad">{season} — Palette</p>
          <h2 className="mt-4 font-display text-4xl font-light leading-tight text-ink lg:text-5xl" data-id="element-181" data-mp="2q68nijegx6yi">
            Three colours, held all season.
          </h2>
        </div>

        <div className="mt-14 grid gap-8 sm:grid-cols-3" data-id="element-182" data-mp="3isjo3u22r7vb">
          {palette.map((colour, i) => <motion.div key={colour.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.7,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-183" data-mp="343nevtoa7ot4" data-mpi={i}>
              <div className="h-40 w-full border border-ink/10" style={{
            backgroundColor: colour.hex
          }} aria-hidden="true" data-id="element-184" data-mp="5fhoncertoby" />
              <h3 className="mt-4 font-display text-xl font-light leading-snug text-ink" data-id="element-185" data-mp="2jxjoyubnd50k">
                {colour.name}
              </h3>
              <p className="mt-1 text-sm font-light text-smoke" data-id="element-186" data-mp="2tu68nfs8lq10">{colour.note}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}